// angular
//     .module("HeroPRO")
//     .controller("TermsSignController", termsSignController);

import './hisCodeOfConduct.scss';

/* @ngInject */
export default function HISCodeOfConductController(NotificationCenterFactory, $rootScope) {
    const vm = this;

    vm.checkboxClicked = false;
    vm.isSubmitting = false;
    vm.invalid = false;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.acknowledgeTerms = function () {
        if (!vm.checkboxClicked) {
            vm.invalid = true;
        } else {
            vm.invalid = false;
            vm.isSubmitting = true;
            const activeNotification = NotificationCenterFactory.getActiveNotification();

            NotificationCenterFactory.setActionItemStatus({
                ActionItemId: activeNotification.ActionItemId,
                ActionItemStatus: 3
            })
            .then(() => {
                vm.isSubmitting = false;
                NotificationCenterFactory.markNotificationComplete(activeNotification.ActionItemId);

                if (NotificationCenterFactory.isLastActiveNotification()) {
                    vm.closeClicked();
                } else {
                    vm.nextClicked();
                }
            })
        }
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.nextClicked = function () {
        NotificationCenterFactory.setNextNotificationAsActive();
        $rootScope.$broadcast('notificationCompleted');
    };

    vm.closeClicked = function () {
        $rootScope.$broadcast('closeNotificationModal');
    };

    vm.doLater = function() {
        if (NotificationCenterFactory.isLastActiveNotification()) {
            $rootScope.$broadcast('closeNotificationModal');
        } else {
            NotificationCenterFactory.setNextNotificationAsActive();
        }
    };
    /* -----  End of Public Functions  ------*/


    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/templates/hisCodeOfConduct/hisCodeOfConduct.js